import { Link } from 'react-router-dom';
import { PageMeta } from '~/components/PageMeta.js';
import { SITE } from '~/content/site.js';

export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-2xl px-5 py-28 sm:px-8">
      <PageMeta title="Page not found" description={SITE.defaultDescription} path="/404" noIndex />
      <p className="section-label">404</p>
      <h1 className="mt-4 display-2">That page does not exist.</h1>
      <p className="mt-4 leading-relaxed text-muted">
        The link may be out of date, or the role it pointed to may have closed.
      </p>
      <Link to="/#open-roles" className="mt-8 inline-block text-primary underline underline-offset-4">
        See the roles that are open
      </Link>
    </div>
  );
}
